/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import classNames from 'classnames';
import './index.scss';
import { HYRouter } from '@hy-hybrid/kiwi-js-sdk';
import BetterScroll from '@better-scroll/core';
import Pulldown from '@better-scroll/pull-down';
import Pullup from '@better-scroll/pull-up';
import Mock from 'mockjs';
import { regFenToYuan, reportFuc } from './../../../../utils';
const { openUrl } = HYRouter;
BetterScroll.use(Pullup);
BetterScroll.use(Pulldown);
interface PropsInterface {
  isDebug: boolean;
  iInvCount: number;
  tTotal: any;
  inved: number;
  setShowDetail: any;
  // setShowPop: any
  setShowShare: any;
  users: any;
  balance: number;
  iOld: boolean;
}
const Random = Mock.Random;
// const data: any = []
// for (let i = 0; i < 8;) {
//   data.push({
//     sAvatarUrl: Random.image(),
//     sNickName: Random.name(),
//     lInvUid: i,
//     lValue: Random.natural(0, 1000),
//     vAward: { value: [] },
//   })
//   i += 1
// }
const { useRef, useEffect, memo } = React;
const InviteInfo: React.FC<PropsInterface> = (props) => {
  const { iOld } = props;
  const bs: React.MutableRefObject<any> = useRef(null);
  const scrollDom: React.MutableRefObject<any> = useRef(null);
  useEffect(() => {
    bs.current = new BetterScroll(scrollDom.current, {
      scrollX: true,
      scrollY: false,
      probeType: 3,
      click: true,
      pullUpLoad: true,
      pullDownRefresh: true
    });
    const Bs = bs.current;
    Bs.on('pullingUp', () => Bs.finishPullUp());
    return () => {
      Bs.destroy && Bs.destroy();
    };
  }, []);
  useEffect(() => {
    const Bs = bs.current;
    if (props.users.length !== 0 && Bs) {
      Bs.refresh();
    }
  }, [props.users]);
  return (
    <>
      <div className={classNames('invite', { new: !iOld })}>
        <div className="invite-cover">
          <h2
            onClick={() => {
              props.setShowDetail(true);
            }}
          >
            已邀请<span>{props.iInvCount}</span>位朋友 <i></i>
          </h2>
          <div className="wrapper">
            <div className="mask left"></div>
            <div className="mask right"></div>
            <div className="invite-wrapper" ref={scrollDom}>
              <ul className="invite-list">
                {props.users.map((item) => {
                  if (item.iStatus != 2 && item.tAward.iTaskStu != 0) {
                    return (
                      <li
                        key={item.lInvedUid}
                        onClick={() => {
                          console.log('profile上报', item.iInvedType);
                          reportFuc(
                            'usr/click/ldx/profile',
                            '用户/点击/老带新/已邀好友区头像点击',
                            { user_type: item.iInvedType }
                          );
                          props.setShowDetail(true);
                        }}
                      >
                        <div className="avatar">
                          <img
                            title={item.sNickName}
                            src={item.sAvatarUrl}
                            onError={(event: any): void => {
                              event.target.onerror = null;
                              event.target.src =
                                'https://diy-assets.msstatic.com/Activity-Public-Image/default-2.png';
                            }}
                          />
                          <div
                            className={classNames('label', {
                              on: true,
                              back: item.iInvedType === 1,
                              newfri: item.iInvedType === 2,
                              old: item.iInvedType === 3
                            })}
                          >
                            ¥
                            {(
                              (item.tAward.lValue + item.tAward.lCash) /
                              100
                            ).toFixed(2)}
                          </div>
                        </div>
                        <p>{item.sNickName}</p>
                      </li>
                    );
                  }
                })}
                {new Array(
                  5 - props.users.length <= 0 ? 1 : 5 - props.users.length
                )
                  .fill(1)
                  .map((item, idx) => (
                    <li
                      key={idx}
                      onClick={() => {
                        reportFuc(
                          'usr/click/ldx/plus',
                          '用户/点击/老带新/已邀好友区加号点击',
                          {}
                        );
                        props.setShowShare(1);
                      }}
                    >
                      <div className="avatar">
                        <div className={classNames('label off')}>
                          {iOld ? '¥20' : '现金礼包'}
                        </div>
                      </div>
                      <p className="name-opactity">待邀请</p>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <div className="invite-cash">
            <div
              className="cash-item"
              onClick={() => {
                reportFuc(
                  'usr/click/ldx/profit',
                  '用户/点击/老带新/累计收益点击',
                  {}
                );
                props.setShowDetail(true);
              }}
            >
              <h3>
                <i className="total" />
                累计收益
              </h3>
              <div className="money-item">
                <div className="money">
                  <h4 className="total">{regFenToYuan(props.tTotal.lValue)}</h4>
                  <h5>元</h5>
                </div>
                <div className="arrow">
                  <i className="icon" />
                </div>
              </div>
            </div>
            <div
              className="cash-item"
              onClick={() => {
                // if (props.inved === 0) return props.setShowPop(true)
                reportFuc(
                  'usr/click/ldx/mainencash',
                  '用户/点击/老带新/活动页提现按钮点击',
                  {}
                );
                openUrl({
                  url: `https://${
                    props.isDebug ? 'test-hd' : 'hd'
                  }.huya.com/h5/task_center/index.html#/cash-out`
                });
              }}
            >
              <h3>
                <i className="cash" />
                现金
              </h3>
              <div className="money-item">
                <div className="money">
                  {/* <h4>{regFenToYuan(props.tTotal.lCash)}</h4> */}
                  <h4>{regFenToYuan(props.balance)}</h4>
                  <h5>元</h5>
                </div>
                <div className="arrow">
                  提现
                  <i className="icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {iOld && (
        <div
          className="tips"
          onClick={() => {
            reportFuc(
              'usr/click/ldx/remind',
              '用户/点击/老带新/提醒朋友按钮点击',
              {}
            );
            props.setShowShare(2);
          }}
        />
      )}
    </>
  );
};
export default memo(InviteInfo);
